// สร้างอัตโนมัติจาก genthemes.py
const THEMES = [
 {
  "id": "snt",
  "name": "KruScan น้ำเงินหมึก (ค่าเริ่มต้น)",
  "swatches": [
   "#0c1833",
   "#2b4f99",
   "#eef3fb",
   "#f6a92e",
   "#f3f5f9"
  ],
  "dark": false
 },
 {
  "id": "navy",
  "name": "กรมท่าสุขุม",
  "swatches": [
   "#16233f",
   "#24407a",
   "#e6ecf7",
   "#f2b544",
   "#f4f6fa"
  ],
  "dark": false
 },
 {
  "id": "kram",
  "name": "ครามโรงเรียน",
  "swatches": [
   "#1f2a5c",
   "#3346a8",
   "#1f2a5c",
   "#f2c14e",
   "#f5f6fb"
  ],
  "dark": false
 },
 {
  "id": "green",
  "name": "เขียวหมึกครู",
  "swatches": [
   "#163a33",
   "#1f6b5c",
   "#e2efeb",
   "#e9a23b",
   "#f3f6f5"
  ],
  "dark": false
 },
 {
  "id": "sky",
  "name": "ฟ้าสว่างมินิมอล",
  "swatches": [
   "#ffffff",
   "#1e4fd8",
   "#f1f4f9",
   "#1e4fd8",
   "#f6f8fb"
  ],
  "dark": false
 },
 {
  "id": "teal",
  "name": "น้ำทะเลเทอร์ควอยซ์",
  "swatches": [
   "#0f3d4a",
   "#0e7c8b",
   "#dff0f2",
   "#ffc857",
   "#f2f7f8"
  ],
  "dark": false
 },
 {
  "id": "maroon",
  "name": "แดงเลือดหมู",
  "swatches": [
   "#4a1a22",
   "#8c2f3d",
   "#f6e9ea",
   "#d9a441",
   "#faf6f5"
  ],
  "dark": false
 },
 {
  "id": "classic",
  "name": "น้ำเงิน-ขาว คลาสสิก",
  "swatches": [
   "#0f2557",
   "#1d4ed8",
   "#0f2557",
   "#ffb703",
   "#f4f6fb"
  ],
  "dark": false
 },
 {
  "id": "pastel",
  "name": "พาสเทลนุ่ม",
  "swatches": [
   "#eef2fb",
   "#3f5fc8",
   "#eaf0fc",
   "#7aa2f7",
   "#fafbfe"
  ],
  "dark": false
 },
 {
  "id": "sakura",
  "name": "ชมพูซากุระ",
  "swatches": [
   "#fdf0f4",
   "#b8345f",
   "#fbe6ee",
   "#e86a92",
   "#fffafc"
  ],
  "dark": false
 },
 {
  "id": "lavender",
  "name": "ลาเวนเดอร์",
  "swatches": [
   "#f3f0fb",
   "#6d55c9",
   "#ece7fa",
   "#7455d0",
   "#fbfaff"
  ],
  "dark": false
 },
 {
  "id": "mint",
  "name": "มิ้นต์สดใส",
  "swatches": [
   "#effaf6",
   "#0f7a5a",
   "#dff5ec",
   "#2bb38a",
   "#f9fdfb"
  ],
  "dark": false
 },
 {
  "id": "night",
  "name": "โหมดกลางคืน",
  "swatches": [
   "#0f131b",
   "#4f7be0",
   "#1f2736",
   "#7aa2f7",
   "#161b25"
  ],
  "dark": true
 }
];
export default THEMES;
export const DEFAULT_THEME = 'snt';
